import { Route, Routes } from "react-router-dom";
import FlowLayout from "@/layout/FlowLayout.jsx";

import SignInPage from "@/modules/Auth/pages/SignInPage.jsx";
import ForgotPasswordPage from "@/modules/Auth/pages/ForgotPasswordPage.jsx";
import RegistrationPage from "@/modules/Auth/pages/RegistrationPage.jsx";

import LocationDatePage from "@/modules/Quote/pages/LocationDatePage.jsx";
import ClassificationPage from "@/modules/Quote/pages/ClassificationPage.jsx";
import LicenseScopePage from "@/modules/Quote/pages/LicenseScopePage.jsx";
import CoveragePage from "@/modules/Quote/pages/CoveragePage.jsx";
import UnderwritingPage from "@/modules/Quote/pages/UnderwritingPage.jsx";
import ReviewPage from "@/modules/Quote/pages/ReviewPage.jsx";
import ArticlesPage from "@/modules/Quote/pages/ArticlesPage.jsx";

import ReviewDocusignPage from "@/modules/Payment/pages/ReviewDocusignPage.jsx";
import PaymentPage from "@/modules/Payment/pages/PaymentPage.jsx";
import BinderInvoicePage from "@/modules/Payment/pages/BinderInvoicePage.jsx";
import CompleteOrderPage from "@/modules/Payment/pages/CompleteOrderPage.jsx";

import DashboardPage from "@/modules/Dashboard/pages/DashboardPage.jsx";
import OrderDetailsPage from "@/modules/Dashboard/pages/OrderDetailsPage.jsx";

import ProfilePage from "@/modules/Profile/pages/ProfilePage.jsx";

import UnderwriterReviewPage from "@/modules/Underwriter/pages/UnderwriterReviewPage.jsx";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/dashboard" element={<DashboardPage />} />
      <Route path="/complete-order" element={<CompleteOrderPage />} />
      <Route path="/binder-invoice" element={<BinderInvoicePage />} />
      <Route path="/signin" element={<SignInPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/order-details" element={<OrderDetailsPage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/articles" element={<ArticlesPage />} />
      <Route path="/underwriter-review" element={<UnderwriterReviewPage />} />
      <Route element={<FlowLayout />}>
        <Route path="/" element={<LocationDatePage />} />
        <Route path="/classification" element={<ClassificationPage />} />
        <Route path="/register" element={<RegistrationPage />} />
        <Route path="/license" element={<LicenseScopePage />} />
        <Route path="/coverage" element={<CoveragePage />} />
        <Route path="/underwriting" element={<UnderwritingPage />} />
        <Route path="/reviewDocusign" element={<ReviewDocusignPage />} />
        <Route path="/payment" element={<PaymentPage />} />
        <Route path="*" element={<LocationDatePage />} />
      </Route>
    </Routes>
  );
}
